import {
  createNumberFormat,
  formatFixed,
  formatInteger,
  formatMoney,
} from "./numberFormat";

export const formatNumber = (num?: number) => {
  if (num === undefined) return "0";
  return formatInteger(num);
};

/**
 * Numero que puede ser desconocido.
 *
 * formatNumber devuelve "0" para undefined, lo que en una metrica de reach es
 * una afirmacion falsa: no es que no se alcanzara a nadie, es que no se sabe.
 * El backend deja esas metricas sin definir precisamente para poder
 * distinguirlo, asi que aqui se respeta.
 *
 * El fallback se puede cambiar por cadena vacia para las filas de CSV, donde
 * una celda en blanco se lee mejor que un guion.
 */
export const formatNumberOrUnknown = (num?: number | null, fallback = "—") =>
  num === undefined || num === null ? fallback : formatNumber(num);

export const formatCurrency = (num?: number, currency?: string) =>
  formatMoney(num ?? 0, currency || "USD", { minDecimals: 2, maxDecimals: 2 });

const percentFormat = () =>
  createNumberFormat({ style: "percent", minimumFractionDigits: 2 });

export const formatPercentage = (num?: number) =>
  percentFormat().format(num ?? 0);

/**
 * Formats a number as a percentage without multiplying by 100.
 * Use this when your value is already in percentage form (e.g., 50 for 50%).
 */
export const formatPercentageNoMultiply = (num?: number) =>
  // Divide by 100 to counteract the automatic multiplication
  percentFormat().format((num ?? 0) / 100);

export const formatDecimal = (num?: number, fractionDigits = 2) =>
  formatFixed(num === undefined || Number.isNaN(num) ? 0 : num, fractionDigits);
